<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ !ta_revised_workflow_note.id ? "Create" : "Edit" }} Step Note</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit(form)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="m-0 px-3 py-4">

    <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Note</mat-label>
      <textarea
        matInput
        placeholder="Note"
        [(ngModel)]="ta_revised_workflow_note.note"
        name="note"
        type="text"
        rows="10"
        cols="30"
        #note
        required
        matTooltip="Enter a step note.">
      </textarea>
      <mat-hint>Please enter a step note.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">

    <button
      *ngIf="canEdit"
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      id="save"
      class="my-2 ml-1 mr-2">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      *ngIf="canDelete"
      type="button"
      mat-icon-button
      [disabled]="!ta_revised_workflow_note.id"
      color="warn"
      class="dialog-remove-button my-2 ml-auto mr-1"
      (click)="onDelete()">
      <mat-icon>delete</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
